webpackJsonp([270829257937027],{

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _contentblock = __webpack_require__(9);
	
	var _contentblock2 = _interopRequireDefault(_contentblock);
	
	var _sidebar = __webpack_require__(18);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _infobox = __webpack_require__(23);
	
	var _infobox2 = _interopRequireDefault(_infobox);
	
	var _mammografie = __webpack_require__(461);
	
	var _mammografie2 = _interopRequireDefault(_mammografie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MammographiePage = function MammographiePage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_page2.default, { headline: 'Mammographie', image: _mammografie2.default }),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom split' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-custom' },
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen zu Hause:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Vermeiden Sie am Tag der Untersuchung ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'jegliche Form von Hautcremes, Deos oder Puder'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Tragen Sie Kleidung ohne ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Metallapplikationen'
	              ),
	              ' (Rei\xDFverschl\xFCsse, Kn\xF6pfe etc.).'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Legen Sie Ihre ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Halsketten'
	              ),
	              ' ab.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Entfernen Sie ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Brustpiercings'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Binden Sie Ihre ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Haare'
	              ),
	              ' zusammen.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Bringen Sie Ihre ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Vorbefunde'
	              ),
	              ' mit (OP-Berichte, R\xF6ntgenbilder etc.).'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Vorbereitungen in der Ordination:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'F\xFCllen Sie in der Ordination das ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Anamneseblatt'
	              ),
	              ' aus.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Durch unsere Mitarbeiter/innen erfolgt eine Aufkl\xE4rung \xFCber das ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'BKFP'
	              ),
	              ' (Brustkrebsfr\xFCherkennungsprogramm).'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Befundsbesprechung:' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Eventuell wird nach der Mammographie noch ein Ultraschall durchgef\xFChrt, wenn der Arzt/die \xC4rztin dies f\xFCr n\xF6tig erachtet.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'F\xFCr die Befundung gilt das 4-Augen-Prinzip: Sie wird durch 2 \xC4rzte/\xC4rztinnen vorgenommen und dauert maximal 1 Woche.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Der Befund wird per Post an die Patient/innen und an den angegebenen oder \xFCberweisenden Arzt/\xC4rztin \xFCbermittelt. Wenn die Patient/innen den Brief nicht innerhalb von 4-6 Wochen erhalten, bitten wir um Kontaktaufnahme mit unserem Institut.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'aside',
	        { className: 'sidebar' },
	        _react2.default.createElement(_sidebar2.default, null),
	        _react2.default.createElement(_infobox2.default, { name: 'mammographie' })
	      )
	    )
	  );
	};
	
	exports.default = MammographiePage;
	module.exports = exports['default'];

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mammografie.7c2af007.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leistungen-mammographie-js-7cdbfd191927182d19de.js